import { FormattedMessage as FM } from "react-intl";

import { ArrowLeftIcon } from "components/Icons";
import { cn } from "tools/ui";

function Layout({ currentView, title, children, style }) {
  return (
    <div id="layout-view" className={cn("w-full px-5", style)}>
      <div className="flex space-x-5 items-center my-3">
        {currentView.value && (
          <ArrowLeftIcon
            className="w-8 h-8 cursor-pointer"
            onClick={() => {
              currentView.value = null;
            }}
          />
        )}

        <h2 className="truncate font-light text-2xl md:text-4xl md:text-neutral-500">
          {currentView.value ? (
            <FM id={currentView.value.name} />
          ) : (
            <FM id={title} />
          )}
        </h2>
      </div>
      {children}
    </div>
  );
}

export default Layout;
